<template>
  <div
    class="checkbox-icon"
  >
    <input
      :id="id"
      :value="value"
      :type="type"
      :required="isRequired"
      :checked="checked"
      class="checkbox-icon__control"
      @keypress="$event.target.classList.add('touched')"
      @change="$emit('change',{'id':$event.target.id,'value':$event.target.value})"
      @click="$emit('click')"
    >
    <label
      class="checkbox-icon__label"
      :for="id"
    >
      <v-icon
        :type="icon"
        size="lg"
      />
    </label>
  </div>
</template>

<script>
import Icon from "@/atoms/Icon";
export default {
  components: {
    "v-icon": Icon
  },
  props: {
    type: {
      type: String,
      default: 'checkbox',
    },
    id: {
      type: [Number,String],
      default: null,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null,
      required: true
    },
    value:{
        type:String,
        default: null
    },
    checked:{
        type: Boolean,
        default: false
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/shared/shared";
.checkbox-icon {
  position: relative;
  padding-left: .2em;
  padding-right: .2em;
  cursor: pointer;
  &__control {
    position: absolute;
    opacity: 0;
    outline: none;
    box-shadow: none;
    cursor: inherit;
  }
  &__label {
    margin-bottom: 0;
    color: rgba($black, .4);
    font-size: inherit;
    cursor: inherit;
    @include transitionOut();
  }
  &__control:checked + &__label {
    color: $azure;
    @include transitionIn();
  }
}
</style>
